// community tab
document.querySelectorAll(".community__top-tab").forEach(tab => {
  tab.addEventListener("click", function () {
    document
      .querySelectorAll(".community__top-tab")
      .forEach(t => t.classList.remove("active"));
    this.classList.add("active");

    document
      .querySelectorAll(".community__bottom")
      .forEach(content => content.classList.remove("active"));

    const target = this.getAttribute("data-target");
    document.getElementById(target).classList.add("active");
  });
});

// header mobile
const burgerButton = document.querySelector(".header-burger");
const menu = document.querySelector(".header__menu-mobile");
const burgerIcon = document.getElementById("burger-icon");

const burgerIconSrc = burgerIcon.dataset.burgerIcon;
const closeIconSrc = burgerIcon.dataset.closeIcon;

burgerButton.addEventListener("click", function () {
  menu.classList.toggle("active");

  if (menu.classList.contains("active")) {
    burgerIcon.src = closeIconSrc;
  } else {
    burgerIcon.src = burgerIconSrc;
  }
});

// faq accordion
document.querySelectorAll('.faq-toggle-button').forEach(button => {
  button.addEventListener('click', function() {
    const textBlock = this.previousElementSibling.querySelector('.faq-content-list-item-block-texts');
    const isActive = textBlock.classList.contains('active');

    document.querySelectorAll('.faq-content-list-item-block-texts').forEach(block => block.classList.remove('active'));
    document.querySelectorAll('.faq-toggle-button').forEach(btn => btn.classList.remove('active'));

    if (!isActive) {
      this.classList.add('active');
      textBlock.classList.add('active');
    }
  });
});


// blog load more
document.addEventListener('DOMContentLoaded', function() {
  const articles = document.querySelectorAll('.blog-page__list-item');
  const loadMoreButton = document.querySelector('.blog-load-more');
  let articlesPerPage = 12;
  let currentPage = 1;

  if(loadMoreButton){
    function showArticles() {
      const start = (currentPage - 1) * articlesPerPage;
      const end = currentPage * articlesPerPage;
  
      articles.forEach((article, index) => {
        if (index >= start && index < end) {
          article.style.display = 'flex';
        }
      });
  
      if (end >= articles.length) {
        loadMoreButton.style.display = 'none';
      }
    }
  
    showArticles();
  
    loadMoreButton.addEventListener('click', function() {
      currentPage++;
      showArticles();
    });
  }
  
});

// article date
document.addEventListener('DOMContentLoaded', function() {
  const dateElements = document.querySelectorAll('.date-element');

  dateElements.forEach(element => {
    let dateText = element.textContent;
    let day = dateText.match(/\d+/)[0];

    let suffix = 'th';
    if (day.endsWith('1') && day !== '11') suffix = 'st';
    else if (day.endsWith('2') && day !== '12') suffix = 'nd';
    else if (day.endsWith('3') && day !== '13') suffix = 'rd';

    element.textContent = dateText.replace(day, day + suffix);
  });
});

// product different
document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.product-different-tabs .tab');
  const contents = document.querySelectorAll('.product-different-contents .product-different-content');

  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      const targetTab = tab.getAttribute('data-tab');

      tabs.forEach(t => t.classList.remove('active'));
      contents.forEach(content => content.classList.remove('active'));

      tab.classList.add('active');

      const targetContent = document.querySelector(`.product-different-content[data-content="${targetTab}"]`);
      if (targetContent) {
        targetContent.classList.add('active');
      }
    });
  });
});

// product main tab
document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.product-main-tabs button');
  
  const tabsContent = document.querySelectorAll('.product-main-tabs-content');

  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      tabs.forEach(btn => btn.classList.remove('active'));

      tab.classList.add('active');

      tabsContent.forEach(content => content.classList.remove('active'));

      const tabNumber = tab.getAttribute('data-main-tab');
      const contentToShow = document.querySelector(`.product-main-tabs-content[data-main-tab-content="${tabNumber}"]`);
      if (contentToShow) {
        contentToShow.classList.add('active');
      }
    });
  });
});

// product quantity
document.addEventListener('DOMContentLoaded', function () {
  const quantityWrappers = document.querySelectorAll('.product-item-quantity');

  quantityWrappers.forEach(wrapper => {
    const input = wrapper.querySelector('.product-quantity-input');
    const plusButton = wrapper.querySelector('.plus');
    const minusButton = wrapper.querySelector('.minus');

    plusButton.addEventListener('click', function () {
      let currentValue = parseInt(input.value, 10);
      if (!isNaN(currentValue)) {
        input.value = currentValue + 1;
      }
    });

    minusButton.addEventListener('click', function () {
      let currentValue = parseInt(input.value, 10);
      if (!isNaN(currentValue) && currentValue > 1) {
        input.value = currentValue - 1;
      }
    });
  });
});

// product variant
document.addEventListener('DOMContentLoaded', function() {
  // Получаем все радиокнопки
  const oneTimePurchaseRadio = document.getElementById('one-time-purchase');
  const subscribePurchaseRadio = document.getElementById('subscribe-purchase');
  
  // Получаем все кнопки подписки
  const subscribeButtons = document.querySelectorAll('#subscribe-options button');
  
  // Логика для отслеживания кликов по радиокнопкам
  if(oneTimePurchaseRadio){
    oneTimePurchaseRadio.addEventListener('change', function() {
      if (this.checked) {
        // Если выбрана "One-time Purchase", убираем активные классы у всех кнопок подписки
        subscribeButtons.forEach(button => button.classList.remove('active'));
        
        // Очищаем значение hidden input для selling_plan
        const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
        sellingPlanInput.value = '';
      }
    });
  }

  if(subscribePurchaseRadio){
     subscribePurchaseRadio.addEventListener('change', function() {
      if (this.checked) {
        // Если выбрана подписка, делаем первую кнопку активной
        subscribeButtons.forEach((button, index) => {
          if (index === 0) {
            button.classList.add('active');
            
            // Устанавливаем значение hidden input для selling_plan
            const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
            sellingPlanInput.value = button.getAttribute('data-plan-id');
          } else {
            button.classList.remove('active');
          }
        });
      }
    }); 
  }
  
  // Логика для клика по кнопкам подписки
  if(subscribeButtons){
    subscribeButtons.forEach(button => {
      button.addEventListener('click', function() {
        // Если нажата кнопка подписки, активируется соответствующий радиокнопочный инпут
        subscribePurchaseRadio.checked = true;
        
        // Обновляем состояние радиокнопок
        subscribeButtons.forEach(btn => btn.classList.remove('active'));
        this.classList.add('active');
        
        // Обновляем hidden input для selling_plan
        const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
        sellingPlanInput.value = this.getAttribute('data-plan-id');
      });
    });
  }
  
});
